import React from 'react';
import { connect } from 'react-redux';
import { Dialog } from '@mui/material';
import { IAppState } from '../../../state/reducers';
import { IProps, IStateProps, IDispatchProps } from './interfaces';
import NotificationSettings from './NotificationSettings/component';
import { toggleNotificationSettings, clearNotificationSettings } from '../../../state/exchange/notificationSettings';

class ExchangeNotificationSettingsDialog extends React.Component<IProps> {
  render() {
    const {
      isOpen,
      onClose,
      onExited,
    } = this.props;

    return (
      <Dialog
        open={isOpen}
        onClose={onClose}
        fullWidth
        maxWidth="lg"
      >
        <NotificationSettings />
      </Dialog>
    );
  }
}

const mapStateToProps = (state: IAppState): IStateProps => ({
  isOpen: state.exchange.notificationSettings.isOpen,
});

const mapDispatchToProps: IDispatchProps = {
  onClose: toggleNotificationSettings,
  onExited: clearNotificationSettings,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(ExchangeNotificationSettingsDialog);
